import Vue from 'vue'
import App from './App.vue'

import store from './store'
import vuetify from './plugins/vuetify'
import { router } from './router'

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter,
  {
    symbol : 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
    avoidEmptyDecimals: undefined,
  })

import './registerServiceWorker'

Vue.config.productionTip = false

// todo: melhorar essa abordagem aqui
// store.subscribe((mutation, state) => {
//   const stateCadastroEmpresa = state['cadastroEmpresa']
//   console.log(state)
//   if(stateCadastroEmpresa) {
//     localStorage.setItem('sistransce-app@cadastroEmpresa', JSON.stringify(stateCadastroEmpresa))
//   }
// })

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
